import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderComponent } from './order.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from 'src/app/shared/shared.module';
import { HeaderModule } from './components/header/header.module';
import { MainModule } from './components/main/main.module';
import { FooterModule } from './components/footer/footer.module';
import { AsideModule } from './components/aside/aside.module';
import { SectionLeftComponent } from './components/section-left/section-left.component';
import { SectionRightComponent } from './components/section-right/section-right.component';
import { FinalComponent } from './components/final/final.component';
import { SectionFullComponent } from './components/section-full/section-full.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { DialogsModule } from 'src/app/shared/dialogs/dialogs.module';



@NgModule({
  declarations: [
    OrderComponent,
    SectionLeftComponent,
    SectionRightComponent,
    FinalComponent,
    SectionFullComponent,
  ],
  imports: [
    FlexLayoutModule,
    CommonModule,
    SharedModule,
    HeaderModule,
    MainModule,
    FooterModule,
    AsideModule,
    AngularSvgIconModule,
    TranslateModule,
    DialogsModule,
  ]
})
export class OrderModule { }
